class World {
    constructor(data) {
        this.is_public = data.is_public;
        this.preferred_language = data.preferred_language;
        this.reset_password_url = data.reset_password_url;
        this.token = data.token ?? data.world_token;
        this.theme = data.theme;
        this.categories = data.categories;
        this.num_categories = data.num_categories;
        this.analytics_code = data.analytics_code;
        this.user_privacy_configuration = data.user_privacy_configuration;
        this.user_directory_configuration = data.user_directory_configuration;
        this.user_can_edit_profile = data.user_can_edit_profile;
        this.user_can_set_difficulty = data.user_can_set_difficulty;
        this.is_brand_login = data.is_brand_login;
    }

    update(data) {
        if (data.hasOwnProperty('app_pages')) this.app_pages = data.app_pages;
        if (data.hasOwnProperty('mode')) this.mode = data.mode;
        if (data.hasOwnProperty('menu')) this.menu = data.menu;
        if (data.hasOwnProperty('id')) this.id = data.id;
        if (data.hasOwnProperty('is_public')) this.is_public = data.is_public;
        if (data.hasOwnProperty('preferred_language')) this.preferred_language = data.preferred_language;
        if (data.hasOwnProperty('reset_password_url')) this.reset_password_url = data.reset_password_url;
        if (data.hasOwnProperty('token')) this.token = data.token;
        if (data.hasOwnProperty('world_token')) this.token = data.world_token;
        if (data.hasOwnProperty('theme')) this.theme = data.theme;
        if (data.hasOwnProperty('categories')) this.categories = data.categories;
        if (data.hasOwnProperty('name')) this.name = data.name;
        if (data.hasOwnProperty('analytics_code')) this.analytics_code = data.analytics_code;
        if (data.hasOwnProperty('num_game_questions')) this.num_game_questions = data.num_game_questions;
        if (data.hasOwnProperty('num_challenge_questions')) this.num_challenge_questions = data.num_challenge_questions;
        if (data.hasOwnProperty('question_points')) this.question_points = data.question_points;
        if (data.hasOwnProperty('question_response_max_time')) this.question_response_max_time = data.question_response_max_time;
        if (data.hasOwnProperty('question_show_answer')) this.question_show_answer = data.question_show_answer;
        if (data.hasOwnProperty('question_extra_time')) this.question_extra_time = data.question_extra_time;
        if (data.hasOwnProperty('is_show_ranking')) this.is_show_ranking = data.is_show_ranking;
        if (data.hasOwnProperty('can_review_question')) this.can_review_question = data.can_review_question;
        if (data.hasOwnProperty('can_send_new_question')) this.can_send_new_question = data.can_send_new_question;
        if (data.hasOwnProperty('question_min_reviews')) this.question_min_reviews = data.question_min_reviews;
        if (data.hasOwnProperty('question_min_correct_reviews')) this.question_min_correct_reviews = data.question_min_correct_reviews;
        if (data.hasOwnProperty('question_added_points')) this.question_added_points = data.question_added_points;
        if (data.hasOwnProperty('question_review_points')) this.question_review_points = data.question_review_points;
        if (data.hasOwnProperty('question_max_characters')) this.question_max_characters = data.question_max_characters;
        if (data.hasOwnProperty('is_show_level_list')) this.is_show_level_list = data.is_show_level_list;
        if (data.hasOwnProperty('shows_help')) this.shows_help = data.shows_help;
        if (data.hasOwnProperty('shows_links')) this.shows_links = data.shows_links;
        if (data.hasOwnProperty('shows_ads')) this.shows_ads = data.shows_ads;
        if (data.hasOwnProperty('show_achievements')) this.show_achievements = data.show_achievements;
        if (data.hasOwnProperty('parse_application_id')) this.parse_application_id = data.parse_application_id;
        if (data.hasOwnProperty('parse_client_key')) this.parse_client_key = data.parse_client_key;
        if (data.hasOwnProperty('game_bets')) this.game_bets = data.game_bets;
        if (data.hasOwnProperty('can_select_category')) this.can_select_category = data.can_select_category;
        if (data.hasOwnProperty('answer_max_characters')) this.answer_max_characters = data.answer_max_characters;
        if (data.hasOwnProperty('question_max_characters')) this.question_max_characters = data.question_max_characters;
        if (data.hasOwnProperty('date_game_end')) this.date_game_end = data.date_game_end;
        if (data.hasOwnProperty('date_game_expired')) this.date_game_expired = data.date_game_expired;
        if (data.hasOwnProperty('message_game_end')) this.message_game_end = data.message_game_end;
        if (data.hasOwnProperty('message_game_expired')) this.message_game_expired = data.message_game_expired;
        if (data.hasOwnProperty('message_cant_play')) this.message_cant_play = data.message_cant_play;
        if (data.hasOwnProperty('message_time')) this.message_time = data.message_time;
        if (data.hasOwnProperty('multimedia_image_show_time')) this.multimedia_image_show_time = data.multimedia_image_show_time;
        if (data.hasOwnProperty('world_tabs')) this.world_tabs = data.world_tabs;
        if (data.hasOwnProperty('start_time')) this.start_time = data.start_time;
        if (data.hasOwnProperty('end_time')) this.end_time = data.end_time;
        if (data.hasOwnProperty('world_allow_challenges')) this.world_allow_challenges = data.world_allow_challenges;
        if (data.hasOwnProperty('sub_title')) this.sub_title = data.sub_title;
        if (data.hasOwnProperty('description')) this.description = data.description;
        if (data.hasOwnProperty('show_hot_spots')) this.show_hot_spots = data.show_hot_spots;
        if (data.hasOwnProperty('world_locales')) this.world_locales = data.world_locales;
        if (data.hasOwnProperty('num_categories')) this.num_categories = data.num_categories;
        if (data.hasOwnProperty('world_feedback_delay')) this.world_feedback_delay = data.world_feedback_delay;
        if (data.hasOwnProperty('world_avatars')) this.world_avatars = data.world_avatars;
        if (data.hasOwnProperty('world_user_icon_mode')) this.world_user_icon_mode = data.world_user_icon_mode;
        if (data.hasOwnProperty('support_email')) this.support_email = data.support_email;
        if (data.hasOwnProperty('time_zone')) this.time_zone = data.time_zone;
        if (data.hasOwnProperty('can_play')) this.can_play = data.can_play;
        if (data.hasOwnProperty('points_documentation')) this.points_documentation = data.points_documentation;
        if (data.hasOwnProperty('can_comment_documentation')) this.can_comment_documentation = data.can_comment_documentation;
        if (data.hasOwnProperty('can_rate_documentation')) this.can_rate_documentation = data.can_rate_documentation;
        if (data.hasOwnProperty('can_favourite_documentation')) this.can_favourite_documentation = data.can_favourite_documentation;
        if (data.hasOwnProperty('profile_customization')) this.profile_customization = data.profile_customization;
        if (data.hasOwnProperty('chat_customization')) this.chat_customization = data.chat_customization;
        if (data.hasOwnProperty('play_in_groups')) this.play_in_groups = data.play_in_groups;
        if (data.hasOwnProperty('inspect_other_groups')) this.inspect_other_groups = data.inspect_other_groups;
        if (data.hasOwnProperty('group_rank_category_id')) this.group_rank_category_id = data.group_rank_category_id;
        if (data.hasOwnProperty('can_share_documents')) this.can_share_documents = data.can_share_documents;
        if (data.hasOwnProperty('documentation_game_mode')) this.documentation_game_mode = data.documentation_game_mode;
        if (data.hasOwnProperty('documentation_difficulties')) this.documentation_difficulties = data.documentation_difficulties;
        if (data.hasOwnProperty('can_upload_documents')) this.can_upload_documents = data.can_upload_documents;
        if (data.hasOwnProperty('world_complete_percentage')) this.world_complete_percentage = data.world_complete_percentage;
        if (data.hasOwnProperty('level_completion')) this.level_completion = data.level_completion;
        if (data.hasOwnProperty('advanced_documentation_view_mode')) this.advanced_documentation_view_mode = data.advanced_documentation_view_mode;
        if (data.hasOwnProperty('can_change_documentation_view_mode')) this.can_change_documentation_view_mode = data.can_change_documentation_view_mode;
        if (data.hasOwnProperty('translation_version')) this.translation_version = data.translation_version;
        if (data.hasOwnProperty('documentation_autoplay')) this.documentation_autoplay = data.documentation_autoplay;
        if (data.hasOwnProperty('world_mode')) this.world_mode = data.world_mode;
        if (data.hasOwnProperty('estimated_game_duration')) this.estimated_game_duration = data.estimated_game_duration;
        if (data.hasOwnProperty('privacy_policy_enabled')) this.privacy_policy_enabled = data.privacy_policy_enabled;
        if (data.hasOwnProperty('last_version_privacy_policy')) this.last_version_privacy_policy = data.last_version_privacy_policy;
        if (data.hasOwnProperty('last_version_use_policy')) this.last_version_use_policy = data.last_version_use_policy;
        if (data.hasOwnProperty('world_integration')) this.world_integration = data.world_integration;
        if (data.hasOwnProperty('show_play_filter')) this.show_play_filter = data.show_play_filter;
        if (data.hasOwnProperty('show_question_filter')) this.show_question_filter = data.show_question_filter;
        if (data.hasOwnProperty('show_favourite_filter')) this.show_favourite_filter = data.show_favourite_filter;
        if (data.hasOwnProperty('show_new_filter')) this.show_new_filter = data.show_new_filter;
        if (data.hasOwnProperty('show_order_filter')) this.show_order_filter = data.show_order_filter;
        if (data.hasOwnProperty('show_link_filter')) this.show_link_filter = data.show_link_filter;
        if (data.hasOwnProperty('show_completed_filter')) this.show_completed_filter = data.show_completed_filter;
        if (data.hasOwnProperty('use_policy_enabled')) this.use_policy_enabled = data.use_policy_enabled;
        if (data.hasOwnProperty('use_policy_title')) this.use_policy_title = data.use_policy_title;
        if (data.hasOwnProperty('use_policy_text')) this.use_policy_text = data.use_policy_text;
        if (data.hasOwnProperty('use_policy_checkbox')) this.use_policy_checkbox = data.use_policy_checkbox;
        if (data.hasOwnProperty('share_times')) this.share_times = data.share_times;
        if (data.hasOwnProperty('chat_support_enabled')) this.chat_support_enabled = data.chat_support_enabled;
        if (data.hasOwnProperty('user_privacy_configuration')) this.user_privacy_configuration = data.user_privacy_configuration;
        if (data.hasOwnProperty('user_directory_configuration')) this.user_directory_configuration = data.user_directory_configuration;
        if (data.hasOwnProperty('user_can_edit_profile')) this.user_can_edit_profile = data.user_can_edit_profile;
        if (data.hasOwnProperty('user_can_set_difficulty')) this.user_can_set_difficulty = data.user_can_set_difficulty;
        if (data.hasOwnProperty('chat_share_documents')) this.chat_share_documents = data.chat_share_documents;
        if (data.hasOwnProperty('documentation_upload_points')) this.documentation_upload_points = data.documentation_upload_points;
        if (data.hasOwnProperty('shows_completion')) this.shows_completion = data.shows_completion;
        if (data.hasOwnProperty('can_like_documents')) this.can_like_documents = data.can_like_documents;
        if (data.hasOwnProperty('is_brand_login')) this.is_brand_login = data.is_brand_login;
        this.documentation_question_time = data.hasOwnProperty('documentation_question_time')  ? data.documentation_question_time : data.question_response_max_time;
    }

    isFinished() {
        return !this.can_play;
    }

    isExpired() {
        return Math.floor(Date.now() / 1000) > this.date_game_expired;
    }

    isFinishedOrIsExpired() {
        return this.isFinished() || this.isExpired();
    }

    isFinishedOrExpired() {
        if (!this.can_play) {

            swal({title: "", text: this.message_cant_play, type: 'warning', confirmButtonText: ''}
                , function (isConfirm) {
                    return true;
                });

            return true;
        }

        if (Math.floor(Date.now() / 1000) > this.date_game_expired) {

            swal({title: "", text: this.message_game_expired, type: 'warning', confirmButtonText: ''}
                , function (isConfirm) {
                    window.blackBox.logout();

                    storage.removeItem('world');
                    storage.removeItem('external_login');
                    location.href = Routing.generate('front_office_homepage');
                    return true;
                });
            return true;
        }
        return false;
    }

    isOpen() {
        // Si coinciden está siempre abierto
        if (this.start_time == this.end_time)
            return true;

        let now = moment();
        let start = moment(this.start_time, "HH:mm");
        let end = moment(this.end_time, "HH:mm");

        return now.isBetween(start, end, "seconds");
    }

    isClosed() {
        return !this.isOpen();
    }

}